import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  field: {
    padding: '15px 15px 0px 15px',
  },
  button: {
    marginTop: 10,
    width: '100%',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFF',
    borderColor: 'rgba(149, 149, 149, 0.4)',
    borderWidth: 0.02,
    color: '#FF9000',
  },
  address: {
    width: '100%',
    minHeight: '70px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid rgba(149, 149, 149, 0.4)',
  },
  body: {
    flex: '1',
    marginLeft: '15px',
    display: 'flex',
    flexDirection: 'column',
  },
  gpsIcon: {
    color: '#999',
  },
  atualLocation: {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  atualLocationText: {
    flexDirection: 'column',
    display: 'flex',
    marginLeft: 13,
  },
  useLocationTitle: {
    fontWeight: 'bold',
    color: '#000',
  },
  useLocationDescription: {
    color: '#999',
    marginTop: 3,
    fontSize: 14,
  },
  icon: {
    color: '#999',
  },
  addresses: {
    background: '#eee',
    padding: '10px 10px 10px 10px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  invalid: {
    color: 'red',
  },
  addressesItem: {
    width: '100%',
    background: '#FFF',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '15px',
    minHeight: '70px',
    borderRadius: 6,
    marginTop: 2,
    marginBottom: 2,
  },
  addressesItemBody: {
    flex: '1',
    marginLeft: '15px',
    display: 'flex',
    flexDirection: 'column',
  },
  addressesItemFields: {
    fontSize: 13,
    color: '#999',
  },
  search: {
    display: 'flex',
    padding: 15,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  autocompleteContainer: {
    display: 'flex',
    background: '#eee',
    flexDirection: 'row',
    height: '56px',
    padding: '9x',
    border: '1px solid rgba(149, 149, 149, 0.4)',
    borderRadius: 3,
    alignItems: 'center',
    marginTop: 3,
  },
  autocompleteText: {
    color: '#999',
  },
  autocompleteIcon: {
    color: '#FF9000',
    marginLeft: 10,
  },
});

export default useStyles;
